module.exports = __webpack_public_path__ + "static/img/areaA-27.f9593c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-27.png
// module id = 939
// module chunks = 1